const buildValidUrlFromContentState = content => {
  if (content.entityMap) {
    Object.keys(content.entityMap).forEach(key => {
      const entity = content.entityMap[key]
      if (entity.type === 'LINK' && entity.data?.url) {
        try {
          let url = entity.data.url

          // If the URL doesn't have a protocol, add https://
          if (!url.match(/^https?:\/\//i)) {
            url = `https://${url}`
          }

          // Create URL object to validate and standardize the URL
          const urlObj = new URL(url)

          // Ensure it uses HTTPS
          if (urlObj.protocol === 'http:') {
            urlObj.protocol = 'https:'
          }

          entity.data.url = urlObj.toString()
        } catch (error) {
          // If URL parsing fails, fall back to the original approach
          const url = entity.data.url
          if (/^http:\/\//i.test(url)) {
            entity.data.url = url.replace(/^http:\/\//i, 'https://')
          } else if (!/^https?:\/\//i.test(url)) {
            entity.data.url = `https://${url}`
          }
        }
      }
    })
  }
  return content
}

export default buildValidUrlFromContentState
